import { PayloadAction } from "@reduxjs/toolkit";
import { SubmitContactsPayload } from "../../../actions/submit-contacts.action.ts";
import { LoanState } from "../loan.slice.ts";

export const submitContactsReducer = (
  state: LoanState,
  action: PayloadAction<SubmitContactsPayload>,
) => {
  state.workflowId = action.payload.workflowId;
  state.contactId = action.payload.contactId;
};
